import { createProvider } from '@nvision/services/data-provider';

import * as api from './api';
import { normalizeLADClaimInitialValues } from './normalize';

export const fetchLADClaimInitialValues = createProvider(api.fetchLADClaimInitialValues)
  .andThen((res) => normalizeLADClaimInitialValues(res))
  .andCatch((error) => {
    if (error instanceof Error && error.name === 'AbortError') {
      console.warn('Fetch list aborted');
    } else {
      console.error('Fetch list was failed:', error);
    }
    throw error;
  });
